import api from './axiosConfig';

/**
 * Request a session with a mentor
 * @param {Object} data { mentorId, sessionType, scheduledAt, duration, message }
 */
export const bookSession = async (data) => {
    try {
        const response = await api.post('/mentor/booking', data);
        return response.data;
    } catch (error) {
        console.error('Book session error:', error);
        throw error.response?.data?.error || error.message || 'Failed to request session';
    }
};

/**
 * Get all sessions requested by the current student
 */
export const getStudentBookings = async () => {
    try {
        const response = await api.get('/mentor/bookings/student');
        return response.data;
    } catch (error) {
        console.error('Fetch student bookings error:', error);
        throw error.response?.data?.error || error.message || 'Failed to fetch bookings';
    }
};

/**
 * Get all sessions requested from the current mentor
 */
export const getMentorBookings = async () => {
    try {
        const response = await api.get('/mentor/bookings/mentor');
        return response.data;
    } catch (error) {
        console.error('Fetch mentor bookings error:', error);
        throw error.response?.data?.error || error.message || 'Failed to fetch bookings';
    }
};

/**
 * Update the status of a booking
 * @param {string} bookingId 
 * @param {string} status 'confirmed', 'cancelled', 'completed'
 */
export const updateBookingStatus = async (bookingId, status) => {
    try {
        const response = await api.put(`/mentor/booking/${bookingId}/status`, { status });
        return response.data;
    } catch (error) {
        console.error('Update booking status error:', error);
        throw error.response?.data?.error || error.message || 'Failed to update status';
    }
};
